<template>
  <div class="volume">
    <div v-if="isMuted" class="button-control" @click="unmute" tabindex="0">
      <sh-icon class="button-control__mute" name="mute" :size="iconSize"/>
    </div>
    <div v-else class="button-control" @click="mute">
      <sh-icon class="button-control__volume" name="volume" :size="iconSize" tabindex="0"/>
    </div>
  </div>
</template>

<script>
import { ShIcon } from '@sohohouse/design-system'

export default {
  name: 'Volume',
  components: {
    ShIcon
  },
  props: {
    isMuted: {
      type: Boolean,
      require: true
    }
  },
  computed: {
    iconSize () {
      return this.$device.isMobile ? 'small' : 'medium'
    }
  },
  methods: {
    unmute () {
      this.$emit('unmute')
    },
    mute () {
      this.$emit('mute')
    }
  }
}
</script>

<style scoped>
.volume {
  cursor: pointer;
}
</style>
